"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stylesOfSizes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledComponents = require("styled-components");

var _types = require("./types");

var _stylesOfSizes;

var stylesOfSizes = (_stylesOfSizes = {}, (0, _defineProperty2["default"])(_stylesOfSizes, _types.Sizes.FLEX, (0, _styledComponents.css)(["min-height:43px;width:initial;overflow:initial;text-overflow:initial;white-space:initial;line-height:16px;padding:7px 0;"])), (0, _defineProperty2["default"])(_stylesOfSizes, _types.Sizes.LARGE, (0, _styledComponents.css)(["height:48px;width:150px;"])), (0, _defineProperty2["default"])(_stylesOfSizes, _types.Sizes.NORMAL, (0, _styledComponents.css)(["height:43px;width:150px;line-height:16px;padding:7px 0;"])), (0, _defineProperty2["default"])(_stylesOfSizes, _types.Sizes.TINY, (0, _styledComponents.css)(["height:34px;max-width:150px;"])), _stylesOfSizes);
exports.stylesOfSizes = stylesOfSizes;